export function detectFramedRun(): { isFramed: boolean; parentDomain: string } {
    const parentLocation = location.ancestorOrigins?.[0] || document.referrer;
    const parentHostName = parentLocation.split('/')[2] || location.hostname;
    return {
        parentDomain: parentHostName?.split(':')[0],
        isFramed: parentHostName?.split(':')[0] !== location.hostname,
    };
}
